module.exports = __webpack_public_path__ + "components/media-kit/static/display-desktop-f79e27c70e230dbc2bdfb0a399221d13.png";